<template>
    <div>
        <v-container >
            <h1 style="text-align:center;margin:20px 0">Redigera</h1>
            <v-form ref="form" lazy-validation>
                <v-text-field
                    v-model="schedule.title"
                    :rules="titleRules"
                    label="Rubrik"
                    required
                    outlined
                    class="inputField"
                ></v-text-field>

                <v-textarea
                    v-model="schedule.description"
                    label="Beskrivning (Frivilligt)"
                    required
                    outlined
                    class="inputField"
                ></v-textarea>

                <v-text-field
                    v-model="schedule.location"
                    label="Plats (Frivilligt)"
                    required
                    outlined
                    class="inputField"
                    style="color:black important"
                ></v-text-field>

                <h3 style="text-weight:bold;color:black;">Tema</h3>
                <div>
                    <v-radio-group
                        class="inputField"
                        true-value="0 "
                        v-model="schedule.theme"
                    >
                        <v-row hide-details>
                            <v-col hide-details>
                                <v-radio
                                    label="Möte"
                                    color="primary"
                                    :value="0"
                                />
                                <v-radio
                                    label="Date"
                                    color="primary"
                                    :value="1"
                                />
                                <v-radio
                                    label="Jobbmöte"
                                    color="primary"
                                    :value="2"
                                />
                            </v-col>
                            <v-col hide-details>
                                <v-radio
                                    label="Svensexa"
                                    color="primary"
                                    :value="3"
                                />
                                <v-radio
                                    label="Möhippa"
                                    color="primary"
                                    :value="4"
                                />

                                <v-radio
                                    label="Middag"
                                    color="primary"
                                    :value="5"
                                />
                            </v-col>
                            <v-col hide-details>
                                <v-radio
                                    label="Resa"
                                    color="primary"
                                    :value="6"
                                />
                                <v-radio
                                    label="Fest"
                                    color="primary"
                                    :value="7"
                                />
                                <v-radio
                                    label="Födelsedag"
                                    color="primary"
                                    :value="8"
                                />
                            </v-col>
                            <v-col hide-details>
                                <v-radio
                                    label="Kalas"
                                    color="primary"
                                    :value="9"
                                />
                                <v-radio
                                    label="Studentskiva"
                                    color="primary"
                                    :value="10"
                                />
                                <v-radio
                                    label="Övrigt"
                                    color="primary"
                                    :value="11"
                                />
                            </v-col>
                        </v-row>
                    </v-radio-group>
                    <v-text-field
                        v-show="schedule.theme == 11"
                        label="Övrigt tema"
                        v-model="schedule.custom_theme"
                        outlined
                    />
                </div>
            </v-form>
            <v-btn
                style="background-color:#ffa500"
                class="mr-4"
                @click="Continue"
            >
                Spara
            </v-btn>
        </v-container>
    </div>
</template>

<script>
import store from "../../store";
import axios from "axios";
export default {
    data: () => ({
        name: "edit",
        id: '',
        store: store,
        location: "",
        schedule: [],
        title: store.state.schedule.title,
        titleRules: [
            v => !!v || "Rubrik krävs",
            v => (v && v.length <= 100) || "Rubrik måste vara 100 tecken lång"
        ],
        description: store.state.schedule.description,
        descRules: [v => !!v || "Beskrivning krävs"],
        theme: 0,
        username: store.state.schedule.username,
        themes: [
            "Möte",
            "Övrigt",
            "Jobbmöte",
            "Svensexa",
            "Möhippa",
            "Middag",
            "Resa",
            "Fest",
            "Födelsedag",
            "Kalas",
            "Studentskiva",
            "Date"
        ],
        customtheme: ""
    }),
    created: async function() {
        this.id= this.$route.params.id
        this.isLoggedIn = this.store.state.isLoggedIn;
        var config = {
            method: "get",
            url: `${this.store.state.baseURL}getschema/${this.id}`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            }
        };
        let resp = await axios(config);
        this.schedule = resp.data.schedule;
    },
    methods: {
        Continue: async function() {
                let bodyFormData = new FormData();
            await bodyFormData.append("id", this.schedule.id);
            bodyFormData.append("title", this.schedule.title);
            bodyFormData.append("description", this.schedule.description);
            bodyFormData.append("location", this.schedule.location);
            bodyFormData.append("theme", this.schedule.theme);
            bodyFormData.append("custom_theme", this.schedule.custom_theme);
            
            var config = {
                method: "post",
                url: `${this.store.state.baseURL}editschema`,
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };
            await axios(config);
            this.$router.replace("/schedule/"+ this.schedule.schedule_link);
        }
    },
};
</script>
<style scoped>
.inputField {
    color: black important;
    border-color: black important;
}
</style>
